module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-es-ES.e1f6427b.jpg";